import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $active?: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-align: left;
    border-radius: 5px;
    padding: 5px;

    user-select: none;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    ${({ $active }) => {
        if ($active)
            return css`
                background-color: ${({ theme }) => theme.colors.purple};

                &:hover {
                    background-color: ${({ theme }) => theme.colors.purpleLight};
                }
            `;
    }}
`;

export const Avatar = styled.div<{ $image: string }>`
    width: 30px;
    height: 30px;
    border-radius: 6px;
    margin-right: 14px;
    flex-shrink: 0;
    background-color: rgba(255, 255, 255, 0.1);

    ${({ $image }) => css`
        background-image: url(${$image});
        background-size: cover;
        background-position: center center;
    `}
`;

export const Info = styled.div`
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
    position: relative;
    gap: 1px;
`;

export const NameText = styled.div`
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: -0.03em;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const MembersText = styled.div`
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: -0.03em;
    color: rgba(255, 255, 255, 0.4);
`;

export const AssetsText = styled.div<{ $noMembers?: boolean }>`
    font-weight: 700;
    font-size: 12px;
    line-height: 120%;
    text-align: right;
    letter-spacing: -0.03em;
    color: #ffffff;

    align-self: flex-start;
    padding-left: 8px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    gap: 4px;

    position: relative;
    top: 3px;
    white-space: nowrap;

    span {
        font-weight: 600;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: -0.03em;
        color: rgba(255, 255, 255, 0.4);
    }

    ${({ $noMembers }) => {
        if ($noMembers)
            return css`
                top: 0;
                align-self: center;
            `;
    }}
`;
